<template>
  <b-modal
    id="mobile-how-modal"
    v-model="show" 
    ok-only 
    centered 
    size="lg" 
    footer-class="border-top d-none d-sm-block"
    header-class="d-none d-sm-block"
    :ok-title="hebrew ? 'סגור' : 'Close'"
    ok-variant="secondary"
    >
    <template slot="modal-header">{{hebrew ? 'איך זה עובד' : 'How it works'}}</template>
    <div class="mobile-modal-top bg-secondary position-fixed w-100 d-block d-sm-none">
      <div class="row">
        <div class="col-8">
          <h3>{{hebrew ? 'איך זה עובד' : 'How it works'}}</h3>
        </div>
        <div @click="show=false" class="close-icon col-4" :class="{'text-left': hebrew, 'text-right': !hebrew}">
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>    
    <div class="how-to-text" v-if="hebrew">
      <p>הכלי לחיפוש תבנית ניקוד  מאתר על בסיס מילת חיפוש מנוקדת, מילים בעלות תבנית ניקוד  דומה בתנ״ך ובתלמוד על פי בחירה.
      </p>
      <h3>תיבת חיפוש</h3>
      <p>
        בתיבת החיפוש החופשי תוכלו להזין 
        <a href="https://nakdan.dicta.org.il/" target="_blank">מילה מנוקדת</a>
          או לבחור מילה מנוקדת מרשימת המילים שתופיע מיד כשתתחילו להזין אותיות בכרטיסייה ״מילה מתוך רשימה״.
          <br>
          בתיבת החיפוש החופשי לא ניתן להזין מילה ללא ניקוד כלל.
      </p>
      <h3>תוצאות</h3>  
      <p>לצד כל תוצאה יצויין מספר הפעמים שהמילה מופיעה במקורות. לחיצה על המילה תציג אותה בתוך הקשרה בכל אחד מהמקורות. כל  מקור יציג את הטקסט באתר 
        <a href="https://sefaria.org.il/" target="_blank">ספריא</a>
      </p>
      <h3>סינון</h3>
      <p>
        ניתן לבחור להציג תוצאות מהתנ״ך או תוצאות מהתלמוד.
      </p>
    </div>
    <div v-else class="how-to-text">
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "about-dialog",
  props: ["value"],
  computed: {
    hebrew () {
      return this.$settings.hebrew
    }, 
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
<style lang="scss">
  @media screen and (max-width: 767px) {
    #mobile-how-modal{
      -webkit-overflow-scrolling: touch;
      .modal-dialog {
        margin: 0!important;
      }
      .modal-content {
        border-radius: 0!important;
        height: 100vh;
        overflow-y: scroll;
        overflow-x:hidden;
        background:white;
      }
      .mobile-modal-top{
          height: 50px;
          top:0;
          right:0;
          padding:15px;
          z-index: 1;
          h3{text-decoration:none;}
      }
      .how-to-text{
          padding-top:50px;
          max-height: 88vh;
          overflow-y: scroll;
          overflow-x:hidden;
      }
      @media screen and (max-width: 667px) {
        .how-to-text{
          max-height: 83vh;
        }
      }      
    }
  }
</style>
<style scoped lang="scss">
.how-to-text {
  max-height: 70vh;
  overflow: auto;
  h3{
  text-decoration: underline;
  }
}
</style>
